export const en = {
  countries: {
    AR: "Argentina",
    BR: "Brazil",
    CL: "Chile",
    CO: "Colombia",
    ES: "Spain",
    US: "United States",
    MX: "Mexico",
    PY: "Paraguay",
    PR: "Puerto Rico",
    UY: "Uruguay",
  },
  countryInfo: {
    AR: {
      description: "is a beautiful country at the bottom of the world. With very friendly people from many cultures. Argentinians love food, talking and laughing with friends, and above all, they are huge football fans.",
      facts: [
        "They are the current football world champions",
        "They love drinking mate",
        "They have the tastiest empanadas in the world",
      ],
    },
    BR: {
      description: "is a country full of colors and joy! It has the largest jungle in the world (the Amazon), incredible beaches and animals like monkeys and toucans. They celebrate Carnival with bright costumes and music that makes everyone dance!",
      facts: [
        "They have monkeys that fit in your hand (marmosets)!",
        "It is the country of football: Pelé and Neymar are from here!",
        "They have a beach with pink sand (in Fernando de Noronha)",
      ],
    },
    CL: {
      description: "is a very long and narrow country, like a ribbon between the sea and the mountains. They have deserts with bright stars, happy penguins in the south and even an island with stone giants called moai.",
      facts: [
        "You can see penguins in Punta Arenas!",
        "They have the driest desert (Atacama), but in winter there are flowers!",
        "Easter Island has mysterious statues (moai)",
      ],
    },
    CO: {
      description: "is like a rainbow of nature: it has golden beaches, green mountains and a river that looks painted in colors (Caño Cristales). Kids love playing with wool pom-poms called 'chumbes'!",
      facts: [
        "They have a river with 5 colors (like a liquid rainbow)",
        "It is the country with the most bird species in the world!",
        "Gabriel García Márquez wrote his magical stories here",
      ],
    },
    ES: {
      description: "is a country with storybook castles, sunny beaches and parties full of music. They invented paella, flamenco and even the tradition of the Three Kings who bring gifts in January!",
      facts: [
        "It has a REAL castle where a dragon lived (the Alcázar of Segovia)",
        "Don Quijote, the knight of the windmills, was born here!",
        "They have a fun battle: La Tomatina (they throw tomatoes as a game)!",
      ],
    },
    US: {
      description: "it's the country of superheroes, amusement parks and grizzly bears! It has deserts with giant cacti, mountains with year-round snow and cities with bright lights like New York.",
      facts: [
        "Its symbol is a bald eagle (but it's not bald, it just has white feathers!)",
        "They have the largest Disney park in the world (in Florida)",
        "They invented the hamburger and the hot dog",
      ],
    },
    MX: {
      description: "is a piñata of colors: it has ancient pyramids, white sand beaches and delicious food like tacos. They celebrate Day of the Dead with sugar skulls and colorful flowers!",
      facts: [
        "They have a volcano where the bravest rabbits live (Popocatépetl)",
        "They invented chocolate and spicy chilis!",
        "They have the longest festival in the world: 9 days of posadas at Christmas!",
      ],
    },
    PY: {
      description: "is a country full of green jungles, giant rivers and exotic animals like macaws. They speak two languages (Spanish and Guaraní) and love drinking tereré (a cold mate for hot days)!",
      facts: [
        "It has the Chaco jungle, home of jaguars and giant armadillos!",
        "They invented the Paraguayan guitar (it sounds like a magic harp!)",
        "They have the largest waterfalls in the world (Iguazú, shared with Argentina and Brazil!)",
      ],
    },
    PR: {
      description: "is an island where the sun always shines! They have white sand beaches, forests with fireflies that glow at night and a fortress where pirates hid treasures. Salsa and reggaeton were born here!",
      facts: [
        "They have a beach that glows in the dark (thanks to magical plankton in Vieques!)",
        "The coquí lives here, a tiny frog that sings 'co-quí' at night",
        "They have a castle called 'El Morro' where people fought against pirates",
      ],
    },
    UY: {
      description: "is a small country but full of surprises: it has endless beaches, real dinosaurs (their fossils!) and the longest carnival in the world. Uruguayans love getting together for barbecues with friends!",
      facts: [
        "They found fossils of a giant dinosaur (the Titanosaur!)",
        "They have the longest beach in the world: Punta del Este (500 km of sand!)",
        "Their carnival lasts 40 days (with parades, drums and costumes!)",
      ],
    },
  },
  common: {
    loading: "Loading...",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    yes: "Yes",
    no: "No",
    error: "Error",
    retry: "Retry",
    close: "Close",
    next: "Next",
    previous: "Previous",
    understood: "Got it!",
    confirm: "Confirm",
    home: "Home",
    flag: "Flag",
    pencil: "Pencil",
    delete: "Delete",
    speak: {
      listen: "Listen to message",
      stop: "Stop reading",
    },
    voice: {
      record: "Record audio",
      stop: "Stop recording",
      errors: {
        unsupported: "Your browser doesn't support voice recognition",
        notAllowed: "Please allow microphone access",
        noSpeech: "No speech detected. Try again",
        audioCapture: "Couldn't access the microphone",
        generic: "Error recording audio",
      },
    },
  },
  language: {
    label: "Language",
    spanish: "Spanish",
    english: "English",
    select: "Select language",
    logout: "Log out",
  },
  auth: {
    welcome: "Welcome to Howe!",
    selectProfile: "Select your profile to continue",
    childLabel: "Child",
    adultLabel: "Adult",
    child: {
      hello: "Hello!",
      enterName: "Write your name to enter",
      namePlaceholder: "E.g.: Sophie, Matthew...",
      nameError: "Enter a valid name (at least 3 letters)",
      loginError: "Login error. Please try again.",
      loggingIn: "Logging in...",
      enter: "Enter!",
      noAccount: "Don't have an account?",
      registerHere: "Register here",
    },
    resetPassword: {
      requestTitle: "Reset password",
      requestDesc: "Enter your email and we'll send you a link to change your password.",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      sendButton: "Send link",
      sending: "Sending...",
      successTitle: "Email sent!",
      successDesc: "If the email exists in Howe, you'll receive a link to change your password.",
      backToLogin: "Back to login",
      confirmTitle: "New password",
      confirmDesc: "Enter your new password.",
      passwordLabel: "New password",
      passwordPlaceholder: "Minimum 8 characters",
      confirmButton: "Save password",
      saving: "Saving...",
      confirmSuccess: "Password changed! You can now log in.",
      invalidToken: "The link is invalid or expired. Request a new one.",
      errorGeneric: "An error occurred. Please try again.",
    },
    invitation: {
      title: "Group Invitation",
      description: "You have been invited to join a group in Howe",
      group: "Group:",
      institution: "Institution:",
      responsible: "Responsible adult:",
      yourName: "Your name:",
      question: "Do you want to accept this invitation?",
      reject: "No, thanks",
      accept: "Yes, accept",
      accepting: "Accepting...",
    },
    adult: {
      title: "Log In",
      email: "Email",
      password: "Password",
      login: "Log in",
      register: "Register",
      loggingIn: "Logging in...",
      loginError: "Invalid credentials",
      noAccount: "Don't have an account?",
      registerHere: "Sign up",
      emailRequired: "Email required",
      passwordRequired: "Password required",
      forgotPassword: "Forgot your password?",
    },
  },
  menu: {
    myEmotions: "MY EMOTIONS",
    myMusic: "MY MUSIC",
    myArt: "MY ART",
    myHowe: "MY HOWE",
    myDiary: "MY DIARY",
    myCommunity: "MY COMMUNITY",
    myLibrary: "MY LIBRARY",
    myRest: "MY REST",
    myRecipes: "MY RECIPES",
    myGames: "MY GAMES",
    myFamilyTree: "MY FAMILY TREE",
    myCommunication: "MY COMMUNICATION",
    welcomeMessage:
      "You can explore your house, click on the room you want to visit. Rooms in grey are not yet available",
    backToMap: "Back to map",
  },
  worldMap: {
    title: "World Map",
    selectCountry: "Select a country",
    myLocation: "My location",
    addCountry: "Add country",
    removeCountry: "Remove country",
    draw: "Draw",
    drawPrompt: "Do you want to draw something about this country?",
    drawCanvas: "Drawing canvas",
    saveDrawing: "Save drawing",
    clearDrawing: "Clear",
    backToMap: "Back to map",
    introTitle: "Welcome to the map!",
    introMessage: "Explore the world by clicking on countries",
    skipIntro: "Skip intro",
    searchCountries: "Search country...",
    countrySelectPrompt: "Where are you from or where did you live?",
    introStep1: "you just entered Howe. My name is **Wobi** and I will always accompany you through your Home.",
    introStep2: "To get started, you have the world available to draw and place your Howe house. Start by adding all the countries you want to include.",
    introStep3: "You can also draw your house in whatever way you like most.",
    introStep4: "When you finish drawing your house you can start exploring it.",
    welcomeHowe: "Hello, welcome to Howe",
    locationNeeded: "We need your location to continue",
    drawingQuestion: "Would you like to draw your HOWE house?",
    nowInCountry: "You are now in",
    goToMenu: "Go to menu",
    drawHouse: "Draw house",
    drawingSaved: "Your house drawing looks beautiful!",
    drawingSuccess: "Your HOWE house is beautiful!",
    drawingSuccessMsg: "You can now enter, decorate, and explore it however you like!",
  },
  room: {
    title: "My Howe",
    save: "Save room",
    saved: "Room saved!",
    changeWall: "Change wall",
    addItem: "Add item",
    backToMenu: "Back to menu",
    explore: "Explore your Howe.",
    changeWallColor: "What color would you like to paint the walls?",
    decorate: "You have everything here. Start decorating your room.",
    designCharacter: "Design your character.",
    backButton: "Back to previous menu",
    wobiTitle: "Hi",
    wobiSubtitle: "This is your Howe room. You can decorate and customize it however you like.",
    wobiRoomTitle: "In your room you can:",
    wobiHint: {
      home: "Go back to the main menu",
      piggy: "Check your HoweCoins piggy bank",
      brush: "Change the wall color",
      box: "Decorate your room with objects",
      avatar: "Customize your avatar",
    },
    insufficientCoins: "You don't have enough balance for this action.",
  },
  diary: {
    roomGreeting: "Hi",
    roomMessage1: "📖 Click on the diary on the desk to write your thoughts for the day. Only you can read it!",
    roomMessage2: "🖼️ Tap the wall frames to decorate them with artwork or upload your own photo.",
    roomMessage3: "🎒 See the backpacks on the coat rack? Click on each one to discover what's inside!",
    coverTitle: "My Diary",
    framePicker: {
      title: "Choose artwork for your wall",
      apply: "Done! 🎨",
      remove: "Remove",
      cancel: "Cancel",
      addFrame: "+ frame",
      uploadPhoto: "📷 Upload photo",
    },
    openDiary: "Open my diary",
    diaryTip: "This room is yours to explore and personalize!",
    memoryShelfTitle: "✨ My Memories",
    backpacksTitle: "🎒 Backpacks",
    backpacks: {
      back: "← Back",
      green: {
        title: "School Backpack",
        items: [
          { e: "📚", l: "Books",       desc: "They hold everything you learn: stories, science, math and more. Every page is a new adventure!" },
          { e: "✏️", l: "Pencils",     desc: "You write, draw and create with them. A pencil can turn your ideas into reality!" },
          { e: "📐", l: "Ruler",       desc: "Helps you draw straight lines and measure things. Perfect for geometry and technical drawing!" },
          { e: "🔬", l: "Science",     desc: "With science you explore the world: animals, plants, space and how everything works. You're a scientist!" },
          { e: "🗺️", l: "Geography",  desc: "It teaches you where countries, rivers and mountains are. The map is your passport to everywhere!" },
          { e: "🧮", l: "Math",        desc: "Add, subtract, multiply and divide. Math is everywhere: in recipes, games and even the stars!" },
        ],
      },
      pink: {
        title: "Sports Backpack",
        items: [
          { e: "⚽", l: "Ball",       desc: "For playing as a team, kicking, passing and celebrating goals together. Sport brings everyone together!" },
          { e: "👟", l: "Sneakers",   desc: "Your best friends for running, jumping and moving. With good sneakers, every path is easier!" },
          { e: "🧢", l: "Cap",        desc: "Protects you from the sun when you train outside. It also gives you a great sporty look!" },
          { e: "💧", l: "Bottle",     desc: "Staying hydrated is super important when you exercise. Your body thanks you with more energy!" },
          { e: "🏃", l: "Running",    desc: "Running strengthens your heart, legs and mind. Every step you take makes you stronger!" },
          { e: "🥊", l: "Gloves",     desc: "For boxing or martial arts. They teach you discipline, strength and respect for others!" },
        ],
      },
      yellow: {
        title: "Art Backpack",
        items: [
          { e: "🖌️", l: "Brushes",   desc: "You paint whatever you imagine. Every brushstroke is a part of you expressing itself on paper!" },
          { e: "🎨", l: "Paints",     desc: "Colors are your words when art is your language. Mix and create unique shades!" },
          { e: "✂️", l: "Scissors",  desc: "For cutting and creating collages. With scissors you can transform paper into art!" },
          { e: "📒", l: "Notebook",   desc: "Your secret space for sketches, ideas and drawings. Every page is a new creative possibility!" },
          { e: "🖍️", l: "Crayons",   desc: "Soft and colorful, perfect for filling in and bringing your drawings to life!" },
          { e: "🌈", l: "Colors",     desc: "The full rainbow at your disposal. Colors have the power to express emotions and tell stories!" },
        ],
      },
    },
    modal: {
      leftTitle: "📖 My Diary",
      rightTitle: "✨ My Thoughts",
      leftPlaceholder: "Write here how you feel today...\n\nWhat happened today that was special?\nWhat was your favorite emotion?",
      rightPlaceholder: "What makes you happy?\n\nYou can paint with words...\nor just write what you feel 💛",
      prevPage: "← Previous",
      nextPage: "Next →",
      pageOf: "Page",
      of: "of",
      close: "Close",
      today: "Today",
      saving: "Saving...",
      loading: "📖 Loading…",
      noEntries: "No entries this month",
      howAreYou: "How are you today?",
      placeholder: "Tell us about your day...",
      listening: "🎤 Listening…",
      changeEmotion: "Change emotion",
      bgTitle: "Background",
      textTitle: "Write",
      micStart: "Dictate to diary",
      micStop: "Stop recording",
      uploadImage: "Upload image",
      takePhoto: "Take photo",
      stickersTitle: "Stickers",
      saveTitle: "Save",
      stickerRemove: "Double-click to remove",
      stickerRemoveTap: "Tap to remove",
      micErrors: {
        unsupported: "Your browser doesn't support voice recognition",
        notAllowed: "Allow microphone access",
        noSpeech: "No voice detected. Try again",
        audioCapture: "Could not access microphone",
        generic: "Recording error",
      },
      days: ["M","T","W","T","F","S","S"],
      dayNames: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
      months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
      monthsShort: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    },
  },
  avatar: {
    title: "CUSTOMIZE YOUR AVATAR",
    gender: "Gender",
    eyes: "Eyes",
    mouth: "Mouth",
    hair: "Hair",
    skin: "Skin tone",
    shirts: "Shirts",
    pants: "Pants",
    shoes: "Shoes",
    saving: "Saving...",
  },
  emotions: {
    labels: {
      alegre: "I feel joy",
      feliz: "I feel happiness",
      confiado: "I feel trust",
      miedoso: "I feel fear",
      enojado: "I feel anger",
      sorprendido: "I feel surprise",
      disgustado: "I feel disgust",
      triste: "I feel sadness",
    },
    jarTitle: "Tap the jar!",
    intro: {
      greeting: "Hello",
      question: "Are you ready to explore your emotions with me?",
      message1: "Did you know your emotions are like superpowers?",
      message2: "Yes, even sadness or anger!",
      message3:
        "Each emotion helps you know yourself better, take care of yourself and express yourself.",
      start: "Let's start!",
      back: "Back",
      roomTitle: "In this room you can:",
      option1: "Talk with me about an emotion you're feeling",
      option2: "Paint your emotions",
      option3: "Tell me if something hurts or bothers you in your body",
      bookHint: "You can also read a lovely story about emotions in the library!",
      jarHint: "Every emotion you feel is saved in the jar like a treasure.",
      activityHint: "And if you want to feel better, open the notebook and pick an activity!",
    },
    selector: {
      greeting: "Hello,\ndo you want to tell me how you feel today?\nChoose an emotion",
      mascotName: "Amby",
    },
    paint: {
      title: "🎨 Paint your emotions",
      subtitle: "Choose a color and bring each heart to life with joy.",
      progress: "hearts painted",
      done: "Done!",
      clear: "Clear",
    },
    names: {
      alegre: "Happy",
      confiado: "Confident",
      disgustado: "Disgusted",
      enojado: "Angry",
      feliz: "Joyful",
      miedoso: "Scared",
      sorprendido: "Surprised",
      triste: "Sad",
    },
    detail: {
      back: "Back",
      learnMore: "Learn more",
    },
    data: {
      alegre: {
        titulo: "Are you happy?",
        subtitulo: "I feel joy",
        descripcion: "Joy is the emotion we feel when something makes us happy, like a reward after something that went well. When we are joyful, we feel full of energy and want to share with others.\nThis emotion helps us connect with other people, be kinder and create good memories together. Joy also makes us want to repeat those things that made us feel good, helping us learn and build bonds.",
      },
      confiado: {
        titulo: "Are you confident?",
        subtitulo: "I feel confidence",
        descripcion: "Confidence arises when we feel secure in ourselves and our abilities.\nIt allows us to face challenges with determination and believe in our possibilities.\nIt is an emotion that helps us make decisions and move forward with confidence.\n\nWhen we cultivate confidence, we develop a positive attitude toward the future and strengthen our self-esteem.",
      },
      disgustado: {
        titulo: "Are you disgusted?",
        subtitulo: "I feel disgust",
        descripcion: "Disgust appears when something seems unpleasant or repulsive to us.\nIt helps us avoid situations or elements that could be harmful.\nIt is a protective emotion that keeps us away from what we consider negative.\n\nWhen we recognize our disgust, we can make healthier decisions and set clear boundaries.",
      },
      enojado: {
        titulo: "Are you angry?",
        subtitulo: "I feel anger",
        descripcion: "Anger arises when something makes us feel attacked or when someone does not respect our limits. It is like a strong energy that activates to help us protect and defend ourselves. Sometimes anger also gives us the drive to pursue our goals, as long as we know how to handle it. This emotion is important for growing and adapting to our surroundings. When we understand why we feel anger, we can use that energy in a way that helps us solve problems instead of complicating them.",
      },
      feliz: {
        titulo: "Are you joyful?",
        subtitulo: "I feel happiness",
        descripcion: "Happiness appears when we experience well-being and satisfaction with our life.\nIt helps us enjoy the present and appreciate what we have.\nIt is an emotion that connects us with gratitude and optimism.\n\nWhen we cultivate happiness, we improve our quality of life and spread positivity to those around us.",
      },
      miedoso: {
        titulo: "Are you scared?",
        subtitulo: "I feel fear",
        descripcion: "Fear is an emotion that appears when we feel that something can hurt us, whether in our body or mind. It is like an alarm that warns us something is wrong and helps us escape or stay still when necessary.\nFear can be very useful! But if we let it grow too much, it can turn into constant worry, as if we are always seeing danger even when it is not really there. That is why learning to look closely at our fears helps us understand them better and overcome them, rather than letting them paralyze or limit us.",
      },
      sorprendido: {
        titulo: "Are you surprised?",
        subtitulo: "I feel surprise",
        descripcion: "Surprise arises when something unexpected happens.\nIt helps us stay alert and adapt to new situations.\nIt is an emotion that keeps us curious and open to learning.\n\nWhen we accept surprise, we can enjoy new experiences and keep an open mind.",
      },
      triste: {
        titulo: "Are you sad?",
        subtitulo: "I feel sadness",
        descripcion: "Sadness appears when we experience loss or disappointment.\nIt helps us process difficult situations and seek support.\nIt is an emotion that allows us to heal and grow emotionally.\n\nWhen we accept our sadness, we can learn from our experiences and strengthen our resilience.",
      },
    },
    chat: {
      header: "Chat with Howe",
      initialQuestion: "Are you",
      predefinedPrompt: "You can choose a reason or write to me…",
      listening: "Listening...",
      placeholder: "Write your answer or press the microphone to speak...",
      predefined: {
        alegre: [
          "I'm happy because I played with my friends and had fun.",
          "Someone I love very much came to visit.",
          "I went on a wonderful outing with my family.",
        ],
        confiado: [
          "I feel confident because I studied and practiced enough.",
          "I know I can do it well.",
          "I feel sure of myself today.",
        ],
        disgustado: [
          "I was disgusted by what happened at school.",
          "I got upset with someone I love.",
          "Because something didn't go as expected.",
        ],
        enojado: [
          "I got angry because nobody listened to me.",
          "I got angry with someone I love.",
          "I got angry because of what happened at school.",
        ],
        feliz: [
          "I'm happy because I shared a fun outing or activity.",
          "I received something I like as a gift.",
          "I got to see someone I love.",
        ],
        miedoso: [
          "Because I felt alone.",
          "I heard a strange noise.",
          "Something scared me at school.",
        ],
        sorprendido: [
          "An unexpected visitor surprised me.",
          "I received a gift without knowing about it.",
          "Something happened that I never imagined.",
        ],
        triste: [
          "I'm sad because I miss someone.",
          "I couldn't see someone I love.",
          "I argued with someone I love very much.",
        ],
      },
    },
  },
  books: {
    modal: {
      prev: "← Previous",
      next: "Next →",
      done: "I'm done! 🎉",
      alreadyRead: "✓ Already read",
      coinEarned: "You earned 10 coins!",
      moral: "I learned that:",
      chapter: "Chapter",
    },
    items: [
      {
        id: 0, emoji: "📖", title: "My emotions",
        chapters: [
          { title: "What are emotions?", text: "Luna didn't understand why she sometimes felt happy, then sad, then angry, all in the same day. One day she asked her grandmother. Her grandmother smiled and said: \"Emotions are like the colors of a rainbow. Each one has its name and its reason.\"", moral: "All your emotions are valid and have a name." },
          { title: "The inner rainbow", text: "Luna discovered she had a rainbow inside her chest. Red was anger, blue was sadness, yellow was joy and violet was calm. \"Is it normal to have so many colors?\" she asked. \"Of course! The more colors you have, the richer your inner life\", her grandmother answered.", moral: "Feeling many different emotions is completely normal." },
          { title: "Hugging your colors", text: "Luna learned not to run away from her emotions. When the blue arrived, she hugged it for a little while. When the red wanted to explode, she breathed deeply. And when the yellow shone, she shared it with everyone.", moral: "Knowing your emotions makes you stronger and happier." },
        ],
      },
      {
        id: 1, emoji: "😄", title: "Joy",
        chapters: [
          { title: "The girl who made everything bloom", text: "Joy was a special girl. Wherever she stepped, flowers bloomed. When she laughed, the sky filled with birds. Children followed her across the rooftops, jumping and singing.", moral: "Joy is one of the best gifts we can share." },
          { title: "The grey town", text: "One day Joy got lost and the town turned grey. Flowers closed up. Birds flew away. A boy remembered something: \"Joy didn't disappear! She's just hiding inside us.\"", moral: "Joy always comes back when we do the things we love." },
          { title: "The dance that changed everything", text: "The boy started dancing alone in the square. At first people stared. Then one joined, then another, then another. Suddenly the whole town was dancing and laughing. And Joy came running back.", moral: "Dancing, laughing and playing are the best medicine for the heart." },
        ],
      },
      {
        id: 2, emoji: "🤬", title: "Anger",
        chapters: [
          { title: "The little red dragon", text: "Anger was a little red dragon with flames in his mouth. He only wanted one thing: to be heard. But everyone was afraid of him and walked away. That made him even angrier.", moral: "Anger tells us when something seems unfair or hurts us." },
          { title: "The wise man's secret", text: "A wise old man didn't run away. He sat next to the little dragon and said: \"When you feel the flames rising, take three very deep breaths.\" The little dragon tried it and, slowly, the fire turned into a small warm light.", moral: "Breathing deeply helps manage anger without hurting anyone." },
          { title: "The magic words", text: "The little dragon learned to say: \"I'm angry because...\" and to explain what was happening. People started to understand him. He no longer needed flames to be heard.", moral: "Putting anger into words is much more powerful than exploding." },
        ],
      },
      {
        id: 3, emoji: "😰", title: "Fear",
        chapters: [
          { title: "The protective shadow", text: "Fear was a tiny shadow that lived under beds and behind doors. But it wasn't evil. It only wanted to protect children from danger.", moral: "Fear exists to protect us. It is not our enemy." },
          { title: "Sofia's conversation", text: "Sofia decided to talk to Fear directly. \"Why do you make me scared?\" The shadow answered softly: \"Because what's coming is important to you. I just want you to be ready.\"", moral: "When we know our fear, it doesn't have as much power." },
          { title: "The brave little step", text: "Sofia understood that being brave doesn't mean having no fear. It means feeling the fear in your belly and going for it anyway, little by little, one step at a time.", moral: "Courage is not the absence of fear, but taking a step even while trembling." },
        ],
      },
      {
        id: 4, emoji: "😢", title: "Sadness",
        chapters: [
          { title: "The blue cloud", text: "Sadness was a soft blue cloud that sometimes came to visit. It wasn't bad, it just wanted to say something important: that something we cared about had changed.", moral: "Sadness is a sign that something mattered to us very much." },
          { title: "Mateo's tears", text: "Mateo learned to let Sadness stay for a little while. He cried a little, and afterwards his heart felt lighter. \"Why do I feel better?\" he asked. \"Because tears clean the heart from the inside\", the cloud answered.", moral: "Crying is okay. Tears clean the heart from the inside." },
          { title: "After the rain", text: "The blue cloud taught Mateo its biggest secret: after every rain, the sky is cleaner and the sun shines brighter. The same happens with the heart.", moral: "After every sadness there is more space in the heart for happiness." },
        ],
      },
      {
        id: 5, emoji: "😌", title: "Calm",
        chapters: [
          { title: "The mountain lake", text: "High up on a very tall mountain there was a crystal-clear lake. Its waters were so still they perfectly reflected the sky, the clouds and the stars. That lake was Calm.", moral: "Calm is a place we can always find inside ourselves." },
          { title: "The secret journey", text: "A girl discovered she could visit that lake without leaving her room. She just had to close her eyes, breathe slowly and count to ten. Suddenly, there was the lake.", moral: "Breathing slowly and closing your eyes are the steps to find calm." },
          { title: "The shared secret", text: "The girl taught the secret to her friends one by one. \"Does it really work?\", they asked. \"Yes\", she said, \"inside each of us there is a quiet place. You just have to know how to get there.\"", moral: "Calm doesn't come from outside. It lives inside you, always ready." },
        ],
      },
      {
        id: 6, emoji: "🥰", title: "Love",
        chapters: [
          { title: "The invisible thread", text: "Love was an invisible thread that connected people. You couldn't see it, but you could feel it: in a tight hug, in someone who truly listens, in a plate of your favorite food made with care.", moral: "Love shows itself in the small gestures of every day." },
          { title: "Without words", text: "A boy was very sad. His dog came over, lay down next to him and rested his head on his legs. He didn't say anything. He just stayed there. And that was enough.", moral: "The purest love sometimes comes without words, just with presence." },
          { title: "The most important love", text: "The girl learned something surprising: the more love she gave, the more love she had. And the most important kind was self-love: taking care of yourself, respecting yourself and being kind to yourself.", moral: "Loving yourself is the first step to loving others well." },
        ],
      },
      {
        id: 7, emoji: "🥹", title: "Pride",
        chapters: [
          { title: "The little sun", text: "Pride was a little sun that shone inside the chest. It appeared when you did something with effort, when you fell and got back up, when you achieved something you thought was impossible.", moral: "Healthy pride comes from your own effort, not from comparing yourself to others." },
          { title: "Valentina's bicycle", text: "Valentina took three weeks to learn to ride a bicycle. She fell many times. But one day she pedaled alone all the way to the end of the street. The little sun in her chest shone like never before.", moral: "Every achievement, no matter how small, deserves to make you feel proud." },
          { title: "Surpassing yourself", text: "Valentina understood that the most beautiful pride is not beating others. It is looking in the mirror and seeing all that you have grown, learned and improved.", moral: "True pride is looking back and seeing all that you have grown." },
        ],
      },
      {
        id: 8, emoji: "😲", title: "Surprise",
        chapters: [
          { title: "The mischievous emotion", text: "Surprise was the most mischievous emotion of all. It appeared when least expected: around a corner, behind a door, in the middle of an ordinary day.", moral: "Surprises remind us that life is full of new things." },
          { title: "Tomás's party", text: "Tomás didn't like surprises. The unknown scared him. But one day his family organized a secret party for him. When he walked in and everyone shouted \"Surprise!\", his heart leaped with joy.", moral: "Sometimes the unexpected brings the happiest moments in life." },
          { title: "Curious eyes", text: "From then on, Tomás started each morning asking himself: \"What incredible thing is waiting for me today?\" And the world filled with wonderful surprises.", moral: "Looking at the world with curious eyes turns ordinary days into adventures." },
        ],
      },
      {
        id: 9, emoji: "😊", title: "Confidence",
        chapters: [
          { title: "The golden seed", text: "Confidence was a golden seed that lived in everyone's heart. It grew with every kind word you said to yourself, with every small achievement, with every time you tried something new.", moral: "Confidence in yourself grows with every small step you take." },
          { title: "Bautista's drawing", text: "Bautista thought he couldn't draw. His teacher looked at him and said: \"You're not bad at drawing. You're a beginner. Every great artist started exactly where you are.\"", moral: "Believing you can learn is the first step to achieving it." },
          { title: "Trying again", text: "Bautista understood that confidence is not coming out perfect the first time. It is knowing that you can try again, learn from the mistake and keep improving.", moral: "Trusting yourself means knowing you can get back up even when you fall." },
        ],
      },
      {
        id: 10, emoji: "☀️", title: "Happiness",
        chapters: [
          { title: "The simple moments", text: "Happiness didn't live in castles or expensive toys. It lived in a warm pizza, in watching rain from under the covers, in a hug for no reason in the middle of the day.", moral: "Happiness lives in the small moments, not only in the big ones." },
          { title: "Mia's search", text: "Mia looked for happiness in new toys and in always winning. One day, hugging her dog in the yard, she found it. Happiness was there, still and quiet, waiting for her to stop.", moral: "Happiness can't be bought or won. You feel it when you are present." },
          { title: "The treasure of moments", text: "Mia learned to collect happy moments like treasures. She kept them in her heart for grey days. And when those days arrived, she took them out one by one.", moral: "Keeping happy moments in your heart helps you through difficult days." },
        ],
      },
      {
        id: 11, emoji: "🤢", title: "Disgust",
        chapters: [
          { title: "The guardian of limits", text: "Disgust was a serious but important guardian. It warned when something wasn't right, when something smelled bad, sounded wrong or felt unfair. It was the one that said: \"This is not good for you.\"", moral: "Disgust protects us from things that hurt us or we don't like." },
          { title: "Camila's words", text: "One day someone said something mean to Camila. Disgust squeezed her chest. Camila breathed and said in a firm voice: \"What you said didn't feel good to me. Please don't do it again.\" And she felt very good.", moral: "Disgust gives us the signal to set limits with clear and kind words." },
          { title: "It's okay not to like everything", text: "Camila learned that it is perfectly okay not to like everything. She doesn't have to eat what she doesn't like, play games she doesn't want to play, or put up with things that hurt her. Saying \"I don't like this\" is an act of self-love.", moral: "Respecting what you don't like is a way of taking care of and loving yourself." },
        ],
      },
    ],
  },
  activities: {
    panelTitle: "Activities to feel better!",
    coins: "coins",
    items: [
      {
        id: "respiracion",
        title: "Deep breathing",
        description: "Breathe deeply 5 times. Inhale through your nose, exhale through your mouth.",
        coins: 10,
      },
      {
        id: "bailar",
        title: "Dance to a song",
        description: "Put on your favorite song and dance non-stop for 2 minutes.",
        coins: 10,
      },
      {
        id: "dibujar",
        title: "Draw how I feel",
        description: "Grab some paper and draw your emotion. What matters is expressing yourself!",
        coins: 10,
      },
      {
        id: "espejo",
        title: "Say something nice to myself",
        description: "Look in the mirror and say 3 nice things about yourself. You are amazing!",
        coins: 10,
      },
      {
        id: "saltos",
        title: "Do 10 jumps",
        description: "Jump with your whole body 10 times. Exercise puts you in a good mood!",
        coins: 10,
      },
      {
        id: "abrazo",
        title: "Ask for a hug",
        description: "Find someone you love and ask them for a big hug.",
        coins: 10,
      },
    ],
  },
  chakra: {
    title: "What do I feel in my body?",
    subtitle: "Touch the part of the body where you feel something",
    back: "Home",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    chakras: {
      corona: {
        name: "Crown Chakra",
        subtitle: "When you have a headache",
        description:
          "This chakra is at the top of your head. When you feel confused, worried or have a headache, this chakra needs attention.",
        question:
          "Do you have a headache or find it hard to think clearly?",
      },
      "tercer-ojo": {
        name: "Third Eye Chakra",
        subtitle: "When your forehead hurts",
        description:
          "This chakra is on your forehead, between your eyes. It helps you concentrate and understand things. When you are very tired or have a headache, this chakra needs help.",
        question:
          "Does your forehead hurt or do you find it hard to concentrate?",
      },
      garganta: {
        name: "Throat Chakra",
        subtitle: "When you have a sore throat",
        description:
          "This chakra is in your throat. It helps you express what you feel and think. When it's hard to speak, you have a sore throat or feel a lump in your throat, this chakra needs attention.",
        question:
          "Do you feel discomfort in your throat or find it hard to say what you think?",
      },
      corazon: {
        name: "Heart Chakra",
        subtitle: "When your chest hurts",
        description:
          "This chakra is in the center of your chest. It is the place of love and emotions. When you feel sad, lonely or have chest pain, this chakra needs care.",
        question:
          "Does your chest feel tight or does your heart hurt?",
      },
      plexo: {
        name: "Solar Plexus Chakra",
        subtitle: "When your stomach hurts",
        description:
          "This chakra is in your stomach. It's where you feel 'butterflies' when you're nervous. When you feel fear, anxiety or have a stomach ache, this chakra needs balance.",
        question:
          "Do you feel butterflies in your stomach, nervousness or stomach pain?",
      },
      sacro: {
        name: "Sacral Chakra",
        subtitle: "When your lower belly hurts",
        description:
          "This chakra is below your navel. It helps you feel creative and joyful. When you feel low on energy or have lower belly pain, this chakra needs attention.",
        question:
          "Do you feel discomfort in your lower belly or feel like you don't want to do anything?",
      },
      raiz: {
        name: "Root Chakra",
        subtitle: "When your lower part hurts",
        description:
          "This chakra is at the lowest part of your body. It makes you feel safe and protected. When you feel insecure, afraid or have pain in the lower part, this chakra needs strengthening.",
        question:
          "Do you feel insecure or have discomfort in the lower part of your body?",
      },
    },
    exploreTitle: "Explore your",
    howToExplore: "How do you want to explore?",
    bodyQuestion: "Do you feel discomfort or pain in this area?",
    introText: "Our body also responds to how we feel: tell me how you're feeling today! Point to the part of your body that bothers or hurts you.",
    actions: {
      Dibujar: "Draw",
      Hablar: "Talk",
      Respirar: "Breathe",
      Imaginar: "Imagine",
    },
    chakrasData: {
      raiz: {
        title: "Root Chakra",
        texto: "Here you connect with your safety and strength by being firm and calm.",
      },
      sacro: {
        title: "Sacral Chakra",
        texto: "This chakra helps you feel pleasure and creativity in your movements.",
      },
      ombligo: {
        title: "Navel Chakra",
        texto: "Feel how your energy flows and helps you process inner emotions.",
      },
      corazon: {
        title: "Heart Chakra",
        texto: "It teaches you to give and receive love with warmth and openness.",
      },
      garganta: {
        title: "Throat Chakra",
        texto: "Express your voice and communicate with confidence and clarity.",
      },
      "tercer-ojo": {
        title: "Third Eye Chakra",
        texto: "Awaken your imagination and intuition to see beyond.",
      },
      corona: {
        title: "Crown Chakra",
        texto: "Connect with your wisdom and spirit to feel inner peace.",
      },
    },
    exercises: {
      corona: {
        title: "My Shining Star",
        exerciseTitle: "✨ Starfall Rain",
        steps: [
          "Raise your arms high toward the sky, as if you want to touch the clouds. Now close your eyes and imagine that little golden and bright stars start to fall from above, very softly.",
          "The little stars fall on your head and slowly travel down your whole body, touching your shoulders, your chest, your belly, your legs... until they reach your feet. While you imagine this, lower your arms very slowly, as if the stars were falling with them.",
          "Feel how the magical little stars take away any discomfort from your head. They are healing stars! 🌟",
        ],
        duration: "⏱️ Do it 3 times slowly",
      },
      "tercer-ojo": {
        title: "My Imagination",
        exerciseTitle: "☁️ The Magic Cloud",
        steps: [
          "Close your eyes gently. With one finger, touch the center of your forehead very softly, right between your eyebrows. Now imagine a cloud appears in your favorite color.",
          "What color is your cloud? Pink? Blue? Golden? Watch how your cloud floats slowly in the sky of your imagination. The cloud moves with the wind, goes one way, then the other, up and down...",
          "Follow your cloud with your mind, as if you were watching a movie. Your magic cloud takes away any discomfort from your forehead. Breathe calmly while you watch it float. 🌈",
        ],
        duration: "⏱️ 1 minute watching your cloud",
      },
      garganta: {
        title: "My Important Voice",
        exerciseTitle: "🦁 The Roaring Lion",
        steps: [
          "Let's be a brave lion! First, sit comfortably and put your hands on your knees.",
          "Now open your mouth wide, wide, WIDE (like a lion when it yawns). Stick your tongue out as far as you can and say \"Aaaaahhh\" very loudly, like a lion's roar. AAAAAHHH! 🦁",
          "Do it 3 times. After roaring like a lion, whisper something very nice you want to say. It can be \"I love myself\" or \"I am brave\" or whatever you like. Say it softly, like a special secret.",
          "This helps your throat relax and feel better. 💙",
        ],
        duration: "⏱️ 3 roars + 1 beautiful whisper",
      },
      corazon: {
        title: "My Loving Heart",
        exerciseTitle: "🦋 Butterfly Hug",
        steps: [
          "Cross your arms over your chest, as if you were giving yourself a hug. Put your right hand on your left shoulder and your left hand on your right shoulder.",
          "Now give yourself gentle pats, first with one hand, then the other, like a butterfly's wings flying: tap-tap, tap-tap, tap-tap. Slowly and with love. 🦋",
          "While doing this, think of someone you love very much: your mom, your dad, your grandma, your pet, your best friend... Feel all the love in your heart. That love is like a warm green light shining in your chest.",
          "The butterfly pats calm your heart and make you feel accompanied. 💚",
        ],
        duration: "⏱️ 1 minute of gentle pats",
      },
      plexo: {
        title: "My Inner Strength",
        exerciseTitle: "🦸 The Superhero",
        steps: [
          "Time to become a superhero! Stand firm with your feet apart (shoulder-width). Put your hands on your hips, like superheroes do.",
          "Puff out your chest, lift your head high and breathe in deeply through your nose. Feel how the air fills your belly with strength and power. ⚡",
          "Now say these words out loud, with great confidence: \"I am strong!\" \"I am brave!\" \"I can do it!\"",
          "Say each phrase 3 times. Feel how your stomach fills with golden and bright energy. You are stronger than you think. 💪✨",
        ],
        duration: "⏱️ Say the 3 phrases, 3 times each",
      },
      sacro: {
        title: "My Happy Belly",
        exerciseTitle: "🌊 Wave Breathing",
        steps: [
          "Lie down or sit comfortably. Put both hands on your belly, just below your navel. Close your eyes if you like.",
          "Imagine your belly is the sea, and when you breathe, you make waves. Breathe in deeply through your nose and feel your belly rise like a big, gentle wave. Then breathe out through your mouth and feel the wave come down slowly. 🌊",
          "Imagine the sea of your belly has a warm orange color, like the sun when it sets. That warm color makes your belly feel comfortable and relaxed.",
          "Wave up... wave down... up... down... Slowly and calmly, like ocean waves on a beautiful day.",
        ],
        duration: "⏱️ Make 8 waves (8 breaths)",
      },
      raiz: {
        title: "My Feet on the Ground",
        exerciseTitle: "🌳 Imaginary Barefoot Walk",
        steps: [
          "Stand firm with your feet well planted on the ground. If you can, take off your shoes to feel the floor better (but it's not required).",
          "Close your eyes and imagine your feet are the roots of a big, strong tree. Those roots start to grow and slowly sink into the earth, going down, down, down... all the way to the very center of the Earth. 🌍",
          "Feel how your roots hold you firm and safe. Nobody can move you because you are well planted, like an ancient tree. Now breathe deeply 5 times, feeling your feet on the ground.",
          "With each breath, imagine your tree grows stronger. Your roots give you strength and make you feel safe and calm. 🌳",
        ],
        duration: "⏱️ 5 deep breaths",
      },
    },
  },
  adult: {
    nav: {
      home: "Home",
      profile: "My Profile",
      groups: "My Groups",
      gestionGrupos: "Group Management",
      gestionGruposNoAdmin: "This feature is only available for institution administrators.",
      statistics: "Statistics",
      visitHowes: "Visit Howes",
    },
    gestion: {
      title: "User & Group Management",
      subtitle: "View groups and users from your institutions",
      institutionLabel: "Institution",
      institutionPlaceholder: "Select an institution",
      loading: "Loading groups...",
      noGroups: "No groups registered for this institution yet.",
      colGroup: "Group",
      colCreador: "Creator",
      colTotal: "Total children",
      colLinked: "With linked account",
      colUnlinked: "Without linked account",
      modalAdultsSubtitle: "Adults responsible for this group",
      modalNoAdults: "No adults assigned",
      modalChildrenAll: "All children in the group",
      modalChildrenLinked: "Children with linked account",
      modalChildrenUnlinked: "Children without linked account",
      modalNoChildren: "No children in this category",
      tagLinked: "Linked",
      usersTitle: "Users",
      usersSubtitle: "Adults with at least one group in this institution",
      colUser: "User",
      colGroups: "Groups",
      colAdmin: "Admin",
      colActions: "Actions",
      adminYes: "Yes",
      adminNo: "No",
      btnSetAdmin: "Make admin",
      btnRemoveAdmin: "Remove admin",
      btnUnlink: "Unlink user from group",
      confirmUnlinkTitle: "Unlink user from institution",
      confirmUnlinkSole: "The user is the sole responsible for the following groups, which will be DELETED:",
      confirmUnlinkShared: "The user will also be removed from these groups (which will continue with other responsible adults):",
      confirmUnlinkQuestion: "Are you sure you want to continue?",
      confirmUnlinkBtn: "Yes, unlink",
      cancelBtn: "Cancel",
      noUsers: "No users registered for this institution yet.",
      colRecibeAlertas: "Receives Howe Alerts",
      toastAlertaOn: "Alerts activated successfully",
      toastAlertaOff: "Alerts deactivated successfully",
      toastAlertaError: "Error updating alert setting",
      grupoConfianzaTitle: "Trust Group",
      grupoConfianzaDesc: "These emails will receive notifications when Howe detects a risk situation.",
      grupoConfianzaVerGrupo: "View Trust Group",
      grupoConfianzaOcultar: "Hide",
      grupoConfianzaUsuarios: "Users with active alerts",
      grupoConfianzaExtra: "Additional emails",
      grupoConfianzaNoUsuarios: "No users have alerts activated for this institution.",
      grupoConfianzaNoExtra: "No additional emails configured.",
      grupoConfianzaAddPlaceholder: "Enter an email",
      grupoConfianzaBtnAdd: "Add",
      grupoConfianzaBtnSave: "Save changes",
      grupoConfianzaSaved: "Trust group updated successfully",
      grupoConfianzaError: "Error updating trust group",
      grupoConfianzaInvalidEmail: "Please enter a valid email",
    },
    home: {
      title: "Welcome to Howe",
      subtitle: "Adult control panel",
      groupsCard: "My Groups",
      groupsCardSub: "groups created",
      statsCard: "Statistics",
      statsCardSub: "View your groups' emotions",
      howesCard: "Visit Howes",
      howesCardSub: "Explore the children's spaces",
    },
    profile: {
      title: "My Profile",
      subtitle: "Personal information and approval status",
      approved: "✓ Profile Approved",
      pending: "⏳ Profile Pending Approval",
      pendingWarning: "Your profile is pending approval by the Howe team. Once approved, you will be able to copy and share invitation links for groups.",
      email: "Email",
      name: "First Name",
      lastName: "Last Name",
      country: "Country",
      stateProvince: "State/Province/City",
      selectCountry: "Select your country...",
      selectState: "Select your province/state...",
      selectCountryFirst: "First select a country...",
      noStates: "No states available for this country",
      save: "Save Changes",
    },
    groups: {
      title: "My Groups",
      subtitle: "Manage the groups of children in your care",
      pendingWarning: "Your profile is pending approval by the Howe team. Once approved, you will be able to copy and share invitation links for groups.",
      noGroups: "You have no groups yet",
      noGroupsDesc: "Create your first group to start managing children's information",
      newGroup: "+ New Group",
      editGroup: "Edit Group",
      deleteGroup: "Delete Group",
      shareGroup: "Share Group",
      shareModalTitle: "Share group",
      shareModalDesc: "Select institution users or enter emails separated by commas.",
      shareModalMembersLabel: "Institution users",
      shareModalEmailLabel: "Enter emails manually (separated by commas)",
      shareModalEmailPlaceholder: "user1@email.com, user2@email.com",
      shareModalNoMembers: "No other adult users registered in this institution.",
      shareSelectAll: "Select all",
      shareDeselectAll: "Deselect all",
      shareCancel: "Cancel",
      shareConfirm: "Share",
      shareSharing: "Sharing...",
      shareInvalidUsers: "The following users are not valid:",
      shareSuccess: "Group shared with {count} user(s) successfully",
      shareNoTarget: "Select at least one user or enter a valid email",
      viewChildren: "👥 View Group Children",
      addChild: "+ Add Child",
      deleteSelected: "🗑️ Delete Selected",
      excelTemplateButton: "⬇️ Download template",
      excelImportButton: "📄 Import from Excel",
      excelImporting: "Importing...",
      refreshChildren: "Refresh",
      excelImportEmpty: "No children found in the spreadsheet for group \"{grupo}\". Check that the \"Nombre del Grupo\" column matches exactly.",
      excelImportSuccess: "Spreadsheet processed successfully: {total} child(ren) added to the group, {success} account(s) created",
      excelImportPending: "{pending} child(ren) were left without an account because that username already existed — invite them manually.",
      excelImportError: "Error processing the spreadsheet. Please try again.",
      childCount: "child(ren) in the group",
      yourRole: "🤝 Your role:",
      noChildren: "No children added",
      colName: "First Name",
      colLastName: "Last Name",
      colGender: "Gender",
      colEmail: "Email",
      colStatus: "Status",
      colActions: "Actions",
      linked: "✓ Linked",
      pendingStatus: "⏳ Pending",
      linkedUser: "👤 User:",
      titleTooltipLinked: "Already linked - User ID:",
      titleTooltipPending: "Profile pending approval",
      titleTooltipCopyLink: "Copy invitation link",
      titleTooltipInstInactive: "The Institution is not Active for inviting children. Contact your Admin.",
      titleTooltipEdit: "Deselect other rows to edit",
      titleTooltipDelete: "Delete",
      instInactiveWarning: "This group is linked to an Inactive institution. Group information cannot be accessed.",
    },
    stats: {
      title: "Emotion Statistics",
      subtitle: "Emotion evolution in your groups",
      institution: "Institution (optional)",
      allInstitutions: "Not specified",
      group: "Group",
      from: "From",
      to: "To",
      selectGroup: "Select a group...",
      selectGroupWarning: "⚠️ Please select a group to view emotion statistics",
      linkedChildren: "Linked children:",
      registeredEmotions: "Registered emotions:",
      workedChakras: "Worked chakras:",
      noData: "Could not load statistics",
      charts: {
        emotionTitle: "Emotion Selection",
        emotionEmpty: "No emotions recorded in the selected period",
        chakraTitle: "Chakra Work",
        chakraEmpty: "No chakras recorded in the selected period",
        totalRecords: "Total records:",
        records: "records",
        analysisTitle: "Group Analysis",
        emotionsLabel: "Emotions",
        chakrasLabel: "Chakras",
        analysisDisclaimer: "* This analysis is automatically generated based on aggregated group data. It does not include individual children's information to preserve their privacy.",
      },
      emotionNames: {
        alegre: "Cheerful",
        confiado: "Confident",
        disgustado: "Disgusted",
        enojado: "Angry",
        feliz: "Happy",
        miedoso: "Fearful",
        sorprendido: "Surprised",
        triste: "Sad",
      },
      chakraNames: {
        raiz: "Root",
        sacro: "Sacral",
        plexo: "Solar Plexus",
        corazon: "Heart",
        garganta: "Throat",
        tercerOjo: "Third Eye",
        corona: "Crown",
        desconocido: "Unknown",
      },
    },
    howes: {
      title: "Visit Howes",
      subtitle: "Select a child's Howe to visit",
      comingSoon: "Coming Soon",
      comingSoonDesc: "This feature will be available soon",
    },
    modal: {
      editGroup: "Edit Group",
      newGroup: "New Group",
      groupName: "Group Name",
      groupNamePlaceholder: "E.g.: My Family, 5th Grade A, etc.",
      yourRole: "Your Role in this Group",
      selectRole: "Select your role...",
      institution: "Institution (optional)",
      noInstitution: "No institution",
      newInstitutionBtn: "+ New",
      cancel: "Cancel",
      saveChanges: "Save Changes",
      createGroup: "Create Group",
      deleteGroupTitle: "Are you sure you want to delete the group?",
      deleteGroupDesc: "This action cannot be undone. The group",
      deleteGroupDesc2: "will be permanently deleted.",
      deleteChildTitle: "Are you sure you want to delete this child?",
      deleteChildDesc: "This action cannot be undone. The child",
      deleteChildDesc2: "will be permanently removed from the group.",
      deleteMultipleTitle1: "Are you sure you want to delete",
      deleteMultipleTitle2: "child",
      deleteMultipleTitle3: "ren",
      deleteMultipleDesc: "This action cannot be undone. The following children will be permanently removed from the group:",
      accept: "Confirm",
      newInstitutionTitle: "New Institution",
      institutionName: "Institution Name",
      institutionNamePlaceholder: "E.g.: Primary School No. 25",
      institutionType: "Institution Type",
      institutionTypeSelect: "Select a type...",
      institutionTypeEducativa: "Educational Institution",
      institutionTypeHogar: "Transitional Home",
      institutionTypeEspecial: "Special Education Institution",
      institutionCountry: "Country",
      institutionState: "State/Province/City",
      institutionAddress: "Address (optional)",
      institutionAddressPlaceholder: "E.g.: 123 Main Street",
      selectCountry: "Select your country...",
      selectState: "Select a state...",
      selectCountryFirst: "First select a country...",
      noStates: "No states available for this country",
      createInstitution: "Create Institution",
      addChild: "Add Child",
      editChild: "Edit Child",
      childNamePlaceholder: "Child's First Name",
      childLastNamePlaceholder: "Child's Last Name",
      childGenderSelect: "Select gender...",
      childBoy: "Boy",
      childGirl: "Girl",
      childNoGender: "Not specified",
      childIdPlaceholder: "Child ID (Optional - Alphanumeric)",
      childEmailPlaceholder: "Email (Optional)",
      save: "Save",
    },
    toast: {
      profileLoadError: "Error loading profile data",
      profileSaved: "✓ Profile updated successfully",
      profileSaveError: "❌ Error updating profile",
      groupCreated: "✓ Group created successfully",
      groupCreateError: "❌ Error creating group",
      institutionCreated: "✓ Institution created successfully",
      institutionCreateError: "❌ Error creating institution",
      groupUpdated: "✓ Group updated successfully",
      groupUpdateError: "❌ Error updating group",
      groupHasChildren: "❌ Cannot delete group because it has associated children",
      groupDeleted: "✓ Group deleted successfully",
      groupDeleteError: "❌ Error deleting group",
      childUpdated: "✓ Child updated successfully",
      childAdded: "✓ Child added successfully",
      childSaveError: "❌ Error saving child",
      childDeleted: "✓ Child deleted successfully",
      childDeleteError: "❌ Error deleting child",
      childrenDeleteError: "❌ Error deleting children",
      childAlreadyLinked: "⚠️ This child is already linked to a user",
      userIdError: "❌ Error: User ID not found",
      childrenLoadError: "❌ Error loading group children",
      statsLoadError: "Error loading group statistics",
      linkCopied: "✓ Invitation link copied for",
      childrenDeleted: "child(ren) deleted successfully",
      identifyGroupError: "❌ Error: Could not identify the group to update",
    },
    roles: {
      grandparent: "Grandparent",
      sibling: "Sibling",
      teacher: "Teacher",
      parent: "Mother/Father",
      other: "Other",
      professor: "Professor",
      psychologist: "Psychologist",
      uncle: "Uncle/Aunt",
      tutor: "Tutor",
    },
  },
  admin: {
    dashboard: {
      title: "Administration Panel",
      users: "Users",
      approve: "Approve",
      reject: "Reject",
      approved: "Approved",
      pending: "Pending",
      all: "All",
      search: "Search",
      noUsers: "No users found",
    },
    usuarios: {
      colRecibeAlertas: "Receives Howe Alerts",
      recibeAlertasSi: "Yes",
      recibeAlertasNo: "No",
      toastAlertaOn: "Alerts activated successfully",
      toastAlertaOff: "Alerts deactivated successfully",
      toastAlertaError: "Error updating alert setting",
      toastHowemakerOn: "Howemaker activated successfully",
      toastHowemakerOff: "Howemaker deactivated successfully",
      toastHowemakerError: "Error updating Howemaker",
    },
    howemakers: {
      navLabel: "⭐ Howemakers",
      title: "Howemakers",
      subtitle: "Manage which users have access to Howemaker features, such as the Family Tree room.",
      refresh: "Refresh",
      searchPlaceholder: "Search by first name, last name, or username...",
      childrenTitle: "Children",
      adultsTitle: "Adults",
      colUsuario: "Username",
      colApellido: "Last name",
      colEdad: "Age",
      colInstitucion: "Institution",
      colHowemaker: "Howemaker",
      si: "Yes",
      no: "No",
      noChildren: "No children to show",
      toastLoadError: "Error loading children",
      toastBulkPartial: "{ok} updated, {failed} could not be updated",
      instFilterAll: "All institutions",
      instFilterNone: "No institution",
      bulkSetSi: "Set Howemaker: Yes",
      bulkSetNo: "Set Howemaker: No",
    },
    cuartos: {
      navLabel: "🏠 Rooms",
      title: "House rooms",
      subtitle: "Configure which rooms are available to all children or only to Howemakers.",
      roomEmotions: "Emotions Room",
      roomHowe: "My Howe Room",
      roomDiary: "Diary",
      roomFamilyTree: "Family Tree",
      visibilityAll: "Everyone",
      visibilityHowemakers: "Howemakers only",
      toastSaved: "Configuration updated successfully",
      toastError: "Error updating configuration",
    },
    instituciones: {
      navLabel: "🏛️ Institutions",
      title: "Institutions",
      subtitle: "List of institutions registered on the platform. Change the status to activate or deactivate.",
      noData: "No institutions registered",
      colInstitucion: "Institution",
      colTipo: "Type",
      colUbicacion: "Location",
      colEstado: "Status",
      colAccion: "Action",
      statusActiva: "Active",
      statusInactiva: "Inactive",
      statusCreada: "Created",
      tipoEducativa: "Educational",
      tipoHogar: "Transit Home",
      tipoEspecial: "Special Education",
      btnActivar: "Activate",
      btnInactivar: "Deactivate",
      btnReactivar: "Reactivate",
      confirmInactivar: "Deactivate institution \"{nombre}\"? Associated groups will not be able to generate invitation links.",
      toastUpdated: "Status updated successfully",
      toastError: "Error updating institution status",
      grupoConfianzaTitle: "Group that receives Howe alerts (Trust Group)",
      grupoConfianzaDesc: "These emails will receive notifications when Howe detects a risk situation in the chat of a child linked to this institution.",
      grupoConfianzaUsuarios: "Users with active alerts",
      grupoConfianzaExtra: "Additional emails",
      grupoConfianzaNoUsuarios: "No users have alerts activated for this institution.",
      grupoConfianzaNoExtra: "No additional emails configured.",
      grupoConfianzaAddPlaceholder: "Enter an email",
      grupoConfianzaBtnAdd: "Add",
      grupoConfianzaBtnSave: "Save changes",
      grupoConfianzaSaved: "Trust group updated successfully",
      grupoConfianzaError: "Error updating trust group",
      grupoConfianzaInvalidEmail: "Please enter a valid email",
      grupoConfianzaVerGrupo: "View Trust Group",
      grupoConfianzaOcultar: "Hide",
    },
  },
  register: {
    options: {
      child: "Child",
      adult: "Adult/Professional",
      alreadyHaveAccount: "Already have an account?",
      signIn: "Sign in",
    },
    child: {
      step1: {
        welcome: "Welcome to Howe!",
        ageQuestion: "How old are you?",
        chooseAvatar: "Choose your avatar:",
        boy: "Boy",
        girl: "Girl",
      },
      step2: {
        nameQuestion: "What is your name?",
        nameSubtitle: "Write the name you will use to play and explore in Howe.",
        namePlaceholder: "Your name",
        acceptTerms: "I accept the",
        termsLink: "terms and conditions",
        acceptPrivacy: "I accept the",
        privacyLink: "privacy policy",
      },
      errors: {
        nameRequired: "Please enter your name",
        ageRequired: "Please enter your age",
        termsRequired: "You must accept the terms and conditions",
        privacyRequired: "You must accept the privacy policy",
        general: "Error registering the child. Please try again.",
      },
    },
    adult: {
      title: "Sign Up",
      subtitle: "Adult/Professional",
      welcome: "Welcome to HOWE, the childhood home of all children.",
      emailPlaceholder: "Enter your email",
      passwordPlaceholder: "Enter your password",
      acceptTermsAndPrivacy: "I accept the",
      termsLink: "Terms and Conditions",
      andThe: "and the",
      privacyLink: "Privacy Policy",
      register: "Sign Up",
      alreadyHaveAccount: "Already have an account?",
      signInHere: "Sign in here",
      errors: {
        invalidEmail: "Please enter a valid email address.",
        passwordTooShort: "Password must be at least 6 characters.",
        termsRequired: "You must accept the terms and conditions to continue.",
        emailAlreadyExists: "You are trying to register with an existing user account",
        allFieldsRequired: "Please complete all required fields.",
        general: "Error completing registration. Please try again.",
      },
      step2: {
        codeInfo: "We sent a 4-digit code to",
        codePlaceholder: "Enter the code",
        validate: "Validate",
        resendCode: "Resend code",
        codeResent: "✓ Code resent successfully",
      },
      step3: {
        personalData: "Personal Data",
        firstNamePlaceholder: "First name",
        lastNamePlaceholder: "Last name",
        selectCountry: "Select your country...",
        selectProvince: "Select your province/state...",
        selectCountryFirst: "First select a country...",
        noStates: "No states available for this country",
        next: "Next",
      },
    },
  },
  piggyBank: {
    title: "My HoweCoins",
    currentBalance: "Current balance",
    howToEarn: "How do you earn coins?",
    spend: "Spend",
    trustedAdult: {
      menuItem: "Linked adults",
      title: "My trusted adult",
      linkedTitle: "Adults linked to my groups",
      wobiMessage: "It is very important for Wobi to know your trusted adult — the person you feel safe with and can tell what is happening to you. It can be a family member, a teacher, or a professional you trust.",
      noTrustedAdult: "Not set",
      namePlaceholder: "Trusted adult's name",
      emailPlaceholder: "Trusted adult's email",
      emailInvalid: "Please enter a valid email address (e.g. name@example.com)",
      saveButton: "Save",
      saveSuccess: "Trusted adult saved successfully!",
      emotionValidation: "To use the emotions chat you must first set a trusted adult.",
      noLinkedAdults: "No adults are linked to your groups yet.",
      back: "Back",
      loading: "Loading...",
    },
    activities: {
      emotions: {
        name: "Talk about my emotions",
        desc: "Tell Wowi how you're feeling",
      },
      body: {
        name: "Register what I feel in my body",
        desc: "Mark where you feel your emotion in your body",
      },
      decorate: {
        name: "Decorate my Howe room",
        desc: "Buy decorations with your HoweCoins",
      },
      story: {
        name: "Listen to a story",
        desc: "Listen to a story about emotions",
      },
      agenda: {
        name: "Complete an agenda activity",
        desc: "Complete a suggested activity",
      },
      diary: {
        name: "Write in my diary",
        desc: "Write down your thoughts for the day",
      },
      diaryPhoto: {
        name: "Upload photo to diary",
        desc: "Decorate the frames in your My Diary room with a photo",
      },
    },
  },
  familyTree: {
    intro: {
      greeting: "Hi! 🌱",
      message: "Your story started long before you were born. Every person in your family brought something unique that helped make you who you are today. Want to discover it with me?",
      inputPlaceholder: "Write something...",
      start: "Let's begin!",
    },
    seed: {
      title: "First let's add YOU, the seed of this tree 🌱",
      nameLabel: "What's your name?",
      namePlaceholder: "Your name",
      dobLabel: "When were you born?",
      funLabel: "Tell me something fun about you",
      funPlaceholder: "My favorite food, my favorite toy...",
      button: "Plant my seed 🌱",
    },
    tree: {
      myEnvironment: "About me",
      zoomLabel: "Zoom",
      unlockGrandparents: "Unlock grandparents",
    },
    node: {
      tabDesc: "About them",
      tabGift: "Soul gift",
      tabMsg: "Messages",
      deceasedLabel: "This family member is no longer with us ☁️",
      toggleDeceasedTitle: "Tap the cloud if this family member is no longer with us",
      photoAvatarLabel: "Photo / Avatar",
      countryLabel: "Country",
      descPlaceholder: "They love cooking and always make me laugh...",
      giftSectionLabel: "A talent or value they gifted you",
      msgPlaceholder: "Write them a message...",
      msgHelper: "Leave them a special saved message",
      saveButton: "Save",
    },
    addModal: {
      namePlaceholder: "NAME",
      addPhoto: "Add photo",
      addButton: "Add",
    },
    countryNames: {
      AR: "Argentina", BR: "Brazil", UY: "Uruguay", CL: "Chile", PY: "Paraguay",
      BO: "Bolivia", MX: "Mexico", ES: "Spain", US: "United States", IT: "Italy",
      FR: "France", DE: "Germany", PE: "Peru", CO: "Colombia", VE: "Venezuela", CU: "Cuba",
    },
    entorno: {
      title: "About me",
      subtitle: "Tell me a bit more about you ✨",
      actividad: "What do you like to do?",
      amigo: "My friends' names",
      comida: "Favorite food",
      color: "Favorite color",
    },
    chat: {
      title: "Wobi",
      inputPlaceholder: "Type...",
      opening: "Hi! Tell me about your family — who you live with, who's important to you. 💛",
      thinking: "Wobi is thinking...",
      error: "Oops, I didn't quite catch that. Can you tell me again? 💛",
      thanks: "How lovely, thanks for sharing! 💛",
      confirmAdd: "Should I add {name} as your {rel}? 💛",
      confirmYes: "Yes",
      confirmNo: "No, different name",
      confirmRetry: "Oh, tell me the name again! ✏️",
      resizeHandle: "Drag to resize the chat",
    },
    bg: {
      title: "Pick the weather 🌤️",
    },
    decorate: {
      title: "Decorate the tree 🌸",
      colorLabel: "Canopy color",
      flowers: "Flowers",
      bugs: "Flying bugs",
    },
    extras: {
      title: "Add a link",
    },
    link: {
      buttonTitle: "Link two family members",
      pickFirst: "🔗 Tap a family member to start linking them",
      pickSecond: "🔗 Now tap who they're linked to",
      question: "How are {a} and {b} related?",
      pareja: "A couple 💑",
      hermano: "Siblings",
      esHijoDe: "is the child of",
      especial: "Special bond 💜",
      removeLine: "Remove this link (keeps both people)",
    },
    typeGroups: {
      fixed: "Family (fixed position)",
      free: "Other links",
    },
    reset: {
      buttonTitle: "Start over",
      title: "Clear the whole tree?",
      warning: "All family members, links and decorations will be deleted. This can't be undone.",
      cancel: "Cancel",
      confirm: "Yes, clear everything",
    },
    detail: {
      photoError: "Couldn't load that photo. Try a different image.",
    },
    nodeLabels: {
      bisAbueloPaterno: "Paternal great-grandfather",
      bisAbuelaPaterna: "Paternal great-grandmother",
      bisAbueloMaterno: "Maternal great-grandfather",
      bisAbuelaMaterna: "Maternal great-grandmother",
      abueloPaterno: "Paternal grandfather",
      abuelaPaterna: "Paternal grandmother",
      abueloMaterno: "Maternal grandfather",
      abuelaMaterna: "Maternal grandmother",
      papa: "Dad",
      mama: "Mom",
      tioPapa: "Uncle / Godfather",
      tioMama: "Aunt / Godmother",
      hermano: "Sibling",
      primo: "Cousin",
      mascota: "Pet",
      especial: "Special person",
      padreAdoptivo: "Adoptive father",
      madreAdoptiva: "Adoptive mother",
      tio: "Uncle/Aunt",
      padrino: "Godfather",
      madrina: "Godmother",
      parejaPapa: "Dad's partner",
      parejaMama: "Mom's partner",
      amigo: "Friend",
      self: "You",
    },
    nodeQuestions: {
      bisAbueloPaterno: "Even if you don't know him, would you like to include him in your tree?",
      bisAbuelaPaterna: "Even if you don't know her, she's part of you. Shall we include her?",
      bisAbueloMaterno: "Even if you don't know him, would you like to include him in your tree?",
      bisAbuelaMaterna: "Even if you don't know her, she's part of you. Shall we include her?",
      abueloPaterno: "What's your dad's father's name?",
      abuelaPaterna: "What's your dad's mother's name?",
      abueloMaterno: "What's your mom's father's name?",
      abuelaMaterna: "What's your mom's mother's name?",
      papa: "Who do you call dad? What's their full name?",
      mama: "Who do you call mom? What's their full name?",
      tioPapa: "Is there someone else on dad's side? An uncle, godfather, or special person?",
      tioMama: "And on mom's side? An aunt, godmother, or special person?",
      hermano: "Do you have siblings? What's their name?",
      primo: "Do they have kids? Let's add your cousin.",
      mascota: "Do you have a pet? What's their name?",
      especial: "Is there a special person, like a godparent or mentor?",
    },
    gifts: ["Courage", "Creativity", "Humor", "Love of music", "Tenderness", "Strength", "Wisdom", "Joy"],
    questions: {
      1: [
        "When were you born? What day and in which city? 🌍",
        "What were you like as a baby? Did anyone tell you something funny? 👶",
        "When did you lose your first tooth? 🦷",
        "Are you the oldest, the middle one, or the youngest? 👨‍👩‍👧",
        "What's your favorite food? 🍕",
      ],
      2: [
        "Who do you call mom? What's her full name? 💛",
        "Who do you call dad? What's his name? 💙",
        "Who takes care of you every day? Who sings you songs? 🎶",
        "Is there someone who's gone but is still important to you? 🌟",
        "What would you give as a gift to whoever takes care of you? 🎁",
      ],
      3: [
        "What's your school's name? What grade are you in? 🏫",
        "Who's your best friend? What do you like to do together? 👫",
        "Do you have any after-school activities? (sports, art, music...) 🎨",
        "What's your favorite season and why? 🌸",
        "Does your family celebrate any special date? 🎄",
      ],
      4: [
        "Who are your grandparents? Do you know them? 👴👵",
        "Where do your grandparents come from? What city or country were they born in? 🌍",
        "What did your grandparents play when they were little? 🎮",
        "Is there someone in your family who's no longer here? Would you like to include them? 🌙",
        "What do you think you inherited from each grandparent? 💫",
      ],
    },
  },
};
